import { css } from 'styled-components';
import { media, rem } from '../../../helpers/mixins';
import { WHITE, GRADIENT_PURPLE_HORIZONTAL, PINK } from '../../../constants/colors';

export default {
  container: css`
    width: 100%;
    min-height: 368px;
    position: relative;
    z-index: 5;
    margin-bottom: 30px;
  `,
  innerWrapper: css`
    color: ${WHITE};
    position: relative;
    z-index: 5;
    padding: 15px;

    ${media.sm`
      width: 250px;
      margin-left: 80px;
    `}
  `,
  content: css`
    font-size: ${rem('14px')};
    position: relative;
    z-index: 5;

    a {
      color: ${PINK};
      font-family: 'Open Sans Bold', sans-serif;
      font-weight: 700;
    }
  `,
  title: css`
    margin-bottom: 15px;
    font-size: ${rem('19px')};
    position: relative;
    z-index: 5;
  `,
  gradientLayer: css`
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: linear-gradient(${GRADIENT_PURPLE_HORIZONTAL});

    ${media.sm`
      width: 544px;
    `}
  `,
};
